module.exports = __webpack_public_path__ + "img/cloud-img.c35ac355.png";